import { BooleanInput } from '@angular/cdk/coercion';
import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';
import { DevstroupeConfigService } from '@devstroupe/services/config';
import { UserModel } from 'app/models/user.model';
import { UserFormComponent } from 'app/modules/configurations/user/form/user-form.component';
import { ApiService } from 'app/shared/apis/api.service';
import { SettingsService } from 'app/shared/settings/settings.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
    standalone: true,
    imports: [MatButtonModule, MatMenuModule, NgIf, MatIconModule, NgClass, MatDividerModule, RouterModule],
})
export class UserComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;

    @Input() isHome: boolean = false;
    user: UserModel;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    schema: string = 'auto';
    isDark: boolean = false;
    isAuto: boolean = false;
    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _settingsService: SettingsService,
        private _devstroupeConfigService: DevstroupeConfigService,
        private dialog: MatDialog,
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to user changes
        ApiService.userCurrent.pipe(takeUntil(this._unsubscribeAll)).subscribe((user: UserModel) => {
            this.user = user;

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
        this._devstroupeConfigService.config$.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
            this.schema = config.scheme;
            this._changeDetectorRef.markForCheck();
            this.isDark = config.scheme == 'dark' || (config.scheme == 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches);
            this.isAuto = config.scheme == 'auto';
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.user) {
            return;
        }

        // Update the user
        // this._userService.update({
        //     ...this.user,
        //     // status,
        // }).subscribe();
    }

    /**
     * Sign out
     */
    signOut(): void {
        this._router.navigate(['/sign-out']);
    }

    toggleSettings() {
        this._settingsService.toggle();
    }

    toggleSchema(): void {
        const currentScheme = this.schema;
        let newScheme: string;

        if (currentScheme === 'auto') {
            newScheme = 'light';
        } else if (currentScheme === 'light') {
            newScheme = 'dark';
        } else {
            newScheme = 'auto';
        }

        this._devstroupeConfigService.config = { scheme: newScheme };
    }

    setTheme(scheme: string): void {
        this._devstroupeConfigService.config = { scheme };
    }

    setThemeAuto() {
        if (this.isAuto && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            this.setTheme('dark');
        } else {
            this.setTheme('auto');
        }
    }

    editUser(): void {
        const config = {
            // type: this.user.profile_type,
            isProfileEdit: true,
        };
        const dialogRef = this.dialog.open(UserFormComponent, {
            data: { ...this.user, config },
        });

        dialogRef.afterClosed().pipe(takeUntil(this._unsubscribeAll)).subscribe();
    }
}
